import { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { NotificationActions } from '../../actions';
import MedicineSetting from './components/MedicineSetting';
// import SettingHome from './components/SettingHome';
// import PrescriptionSetting from './components/PrescriptionSetting';
import MedicineInstitutions from './components/MedicineInstitutions';
import MedicineSpecialist from './components/MedicineSpecialists';
import MedicationTime from './components/MedicationTime';
import MedicationRemark from './components/MedicationRemark';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            <Card>
                <CardContent>
                    {value === index && children}
                </CardContent>
            </Card >
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};


function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}




const tabs = [
    //{ title: '設定主頁', component: <SettingHome /> },
    { title: '藥物設定', component: <MedicineSetting /> },
    //{ title: '藥紙設定', component: <PrescriptionSetting /> },
    { title: '藥物來源', component: <div><MedicineInstitutions /> <MedicineSpecialist /></div> },
    { title: '用藥時間', component: <MedicationTime /> },
    { title: '服用備註', component: <MedicationRemark /> },

];

export default function MedicineSettingPage() {
    const [tabActiveValue, setTabActiveValue] = useState(0);
    const dispatch = useDispatch();

    const handleTabChange = (event, newValue) => {
        setTabActiveValue(newValue);
        dispatch(NotificationActions.clear());
    };

    return (
        <div>
            <Typography variant="h2" component="h2" style={{ marginBottom: 15 }}>藥物設定</Typography>
            <AppBar position="static" color="default" style={{ marginBottom: 15 }}>
                <Tabs
                    value={tabActiveValue}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    {
                        tabs && tabs.map((tab, index) => {
                            return <Tab key={index} label={tab.title} disabled={tab.disabled} {...a11yProps(index)} />
                        })
                    }
                </Tabs>
            </AppBar>

            <Grid container spacing={2}>
                <Grid item md={12} xs={12}>
                    {
                        tabs && tabs.map((tab, index) => {
                            return (
                                <TabPanel key={index} value={tabActiveValue} index={index}>
                                    {tab.component || <h3>{tab.title}</h3>}
                                </TabPanel>
                            );
                        })
                    }
                </Grid>
            </Grid>
        </div>
    );
}